import { cache } from "react"
import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getAllPosts = cache(async () => {
  try {
    const response = await directusServer.query(`
     query allWebsiteConfig {
				webpage_config {
					blog_welcome_msg
					blog_hero_img {
						id
						filename_download
						width
						height
					}
					case_study_welcome_msg
					case_study_hero_img {
						id
						filename_download
						width
						height
					}
				}
			}
	 	 `)
    // console.log(response);

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.log(error)
    return null
  }
})

export default getAllPosts
